import { signOut } from "next-auth/react";
import Link from "next/link";

export function ProfileDropdown() {
  return (
    <div className="absolute right-3 bg-blue-600 shadow-md z-50 top-10  rounded-sm">
      <ul className="w-60 p-2">
        <li>
          <Link
            href="/blog"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Blog
          </Link>
        </li>
        <li>
          <Link
            href="/blog/profile"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Profile
          </Link>
        </li>
        <li>
          <Link
            href="/blog?published=true"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Published
          </Link>
        </li>
        <li>
          <Link
            href="/blog/drafts"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Drafts
          </Link>
        </li>
        <li>
          <Link
            href="/blog/bookmarks"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Bookmarks
          </Link>
        </li>
        <li>
          <Link
            href="/blog?scheduled=true"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Scheduled
          </Link>
        </li>
        <li>
          <Link
            href="/blog?deleted=true"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Trash
          </Link>
        </li>
        <li>
          <Link
            href="/blog?archived=true"
            className="px-3 py-2 hover:bg-blue-800 rounded-sm block"
          >
            Archived
          </Link>
        </li>
      </ul>
      <hr />
      <div className="p-2 ">
        <button
          className="px-3 py-2 text-left hover:bg-blue-800 rounded-sm block w-full"
          onClick={() => signOut()}
        >
          Logout
        </button>
      </div>
    </div>
  );
}
